import styled from 'styled-components';
export const OptionWrapper = styled.div`
  background: transparent;
  padding: 9.5px 12px;
  color: #353b60;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  user-select: none;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 0 12px;
  word-break: break-all;

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;